<div class="edit-profile-container">
    <!-- Page Header -->
    <section class="page-header">
        <div class="title-container">
            <!-- Page Title Section -->
            <div class="title-section">
                <h1 class="h1-value font-size-22px">Edit Profile</h1>
                <span class="sub-title font-size-12px"
                    >Make changes to your Profile below</span
                >
            </div>
        </div>

        <profile-messaging-container
            [radiusType]="'square'"
            class="profile-messaging-section"
        ></profile-messaging-container>
    </section>

    <section>
        <div fxLayout="column" fxLayoutAlign="center center">
            <mat-tab-group class="profile-tab-group">
                <mat-tab label="User Settings">
                    <div class="edit-profile-tab-content">
                        <edit-profile
                            [profileData]="profileData$ | async"
                        ></edit-profile>
                    </div>
                </mat-tab>
                <mat-tab label="Profile Image">
                    <div
                        class="edit-profile-tab-content"
                        fxLayout="column"
                        fxLayoutAlign="center center"
                    >
                        <div fxFlex="50">
                            <profile-thumbnail
                                [profileData]="profileData$ | async"
                            >
                            </profile-thumbnail>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Change Password">
                    <div class="edit-profile-tab-content">
                        <change-password-component
                            [profileData]="profileData$ | async"
                        ></change-password-component>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>
    </section>
</div>
